import React, { useEffect, useState } from 'react';
import { Container, Row, Stack } from 'react-bootstrap';
import { asve } from '../orve';
import { getAssessmentContentPercentile, getAssessmentContentBlank, getAssessmentText } from '../report-util';
import { getExperienceBreakpoints, getExperienceSummary, getExperienceTitle } from '../assessment-verbiage';
import { REPORT_TYPE } from '../../../../utils/constants';

function ExperienceJudgmentResults({ candidate, reportType }) {
  const [assessmentText, setAssessmentText] = useState({});
  const isStaffing = reportType === REPORT_TYPE.staffing;
  const situationalBreakPointsExperience = {
    breaks: [4, 3],
    scale: 5,
  };
  const situationalBreakPointsJudgment = {
    breaks: [3, 2],
    scale: 3,
  };

  useEffect(() => {
    if (candidate) {
      setAssessmentText(asve(candidate));
    }
  }, [candidate]);

  return (
    <Container className="bg-white mt-2 mb-3 candidate-profile-assessments">
      {candidate && (
        <>
          <Container className="candidate-profile-assessment-content">
            <Row className="w-50 justify-content-left">
              <h3 className="pt-4 pb-1">EXPERIENCE</h3>
              {!isStaffing && (
                <Stack direction="horizontal" gap={4}>
                  {getAssessmentContentPercentile('Overall Experience', candidate.percentiles.experience, reportType)}
                </Stack>
              )}
            </Row>
            <Row className="w-100 pb-3">
              {getAssessmentText(isStaffing ? assessmentText.staffingExperience : assessmentText.experience)}
            </Row>
            {!candidate.experience.variableKeys ? (
              <Row className="w-100 mx-auto justify-content-center pt-2">
                <Stack direction="horizontal" className="subscore-chart">
                  <div className="w-25">
                    {getAssessmentContentBlank(
                      'Risk Taking',
                      candidate.experience.scores.riskTaking,
                      situationalBreakPointsExperience,
                      reportType
                    )}
                  </div>
                  <div className="w-75 mt-3">{getAssessmentText(assessmentText.riskTaking)}</div>
                </Stack>
                <Stack direction="horizontal" className="subscore-chart">
                  <div className="w-25">
                    {getAssessmentContentBlank(
                      'Conflict Resolution',
                      candidate.experience.scores.conflictResolution,
                      situationalBreakPointsExperience,
                      reportType
                    )}
                  </div>
                  <div className="w-75 mt-3">{getAssessmentText(assessmentText.conflictResolution)}</div>
                </Stack>
                <Stack direction="horizontal" className="subscore-chart">
                  <div className="w-25">
                    {getAssessmentContentBlank(
                      'Dealing with Conflict',
                      candidate.experience.scores.dealingWithConflict,
                      situationalBreakPointsExperience,
                      reportType
                    )}
                  </div>
                  <div className="w-75 mt-3">{getAssessmentText(assessmentText.dealingWithConflict)}</div>
                </Stack>
                <Stack direction="horizontal" className="subscore-chart">
                  <div className="w-25">
                    {getAssessmentContentBlank(
                      'Meeting Facilitation',
                      candidate.experience.scores.meetingFacilitation,
                      situationalBreakPointsExperience,
                      reportType
                    )}
                  </div>
                  <div className="w-75 mt-3">{getAssessmentText(assessmentText.meetingFacilitation)}</div>
                </Stack>
                <Stack direction="horizontal" className="subscore-chart">
                  <div className="w-25">
                    {getAssessmentContentBlank(
                      'Direct Communication',
                      candidate.experience.scores.directCommunication,
                      situationalBreakPointsExperience,
                      reportType
                    )}
                  </div>
                  <div className="w-75 mt-3">{getAssessmentText(assessmentText.directCommunication)}</div>
                </Stack>
              </Row>
            ) : (
              <Row className="w-100 mx-auto justify-content-center pt-2">
                <>
                  {candidate.experience.variableKeys.map((key) => {
                    const title = getExperienceTitle(candidate, key);
                    if (title) {
                      return (
                        <Stack key={key} direction="horizontal" className="subscore-chart">
                          <div className="w-25">
                            {getAssessmentContentBlank(
                              title,
                              candidate.experience.scores[key],
                              getExperienceBreakpoints(candidate),
                              reportType
                            )}
                          </div>
                          <div className="w-75">{getExperienceSummary(candidate, key)}</div>
                        </Stack>
                      );
                    }
                  })}
                </>
              </Row>
            )}
            <Row className="mt-2 w-50 justify-content-left">
              <h3 className="pt-4 pb-1">JUDGMENT</h3>
              {!isStaffing && (
                <Stack direction="horizontal" gap={4}>
                  {getAssessmentContentPercentile('Overall Judgment', candidate.percentiles.judgment, reportType)}
                </Stack>
              )}
            </Row>
            <Row className="w-100 pb-3">
              {getAssessmentText(isStaffing ? assessmentText.staffingJudgment : assessmentText.judgment)}
            </Row>
            <Row className="w-100 mx-auto justify-content-center pt-2">
              <Stack direction="horizontal" className="subscore-chart">
                <div className="w-25">
                  {getAssessmentContentBlank(
                    'Building Cohesive Teams',
                    candidate.situationalJudgment.scores.buildingCohesiveTeams,
                    situationalBreakPointsJudgment,
                    reportType
                  )}
                </div>
                <div className="w-75 mt-2">{getAssessmentText(assessmentText.buildingCohesiveTeams)}</div>
              </Stack>
              <Stack direction="horizontal" className="subscore-chart">
                <div className="w-25">
                  {getAssessmentContentBlank(
                    'Building Resilient Teams',
                    candidate.situationalJudgment.scores.buildingResilientTeams,
                    situationalBreakPointsJudgment,
                    reportType
                  )}
                </div>
                <div className="w-75 mt-3">{getAssessmentText(assessmentText.buildingResilientTeams)}</div>
              </Stack>
              {!isStaffing && (
                <Stack direction="horizontal" className="subscore-chart">
                  <div className="w-25">
                    {getAssessmentContentBlank(
                      'Executing for Results',
                      candidate.situationalJudgment.scores.executingForResults,
                      situationalBreakPointsJudgment,
                      reportType
                    )}
                  </div>
                  <div className="w-75 mt-3">{getAssessmentText(assessmentText.executingForResults)}</div>
                </Stack>
              )}
            </Row>
          </Container>
        </>
      )}
    </Container>
  );
}

export default ExperienceJudgmentResults;
